export const SET_WARRANTY_DATA = 'SET_WARRANTY_DATA';
